// extracted by mini-css-extract-plugin
module.exports = {"l1nnx58z":"l1nnx58z","c1hrevmk":"c1hrevmk","bchla9n":"bchla9n"};